
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"84","height":"104","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#B9BBBD","stroke-width":"4","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M52 2H12C6.477 2 2 6.477 2 12v80c0 5.523 4.477 10 10 10h60c5.523 0 10-4.477 10-10V32L52 2z"}}),_c('path',{attrs:{"d":"M52 2v30h30M62 57H22M62 77H22M32 37H22"}})])])
          )
        }
      }
    